<template>
  <div class="message-wrp">
    <section>
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索标题关键字" v-model="searchInput">
        </div>
        <div class="search-icon" @click="getList">
          搜索
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="getList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="message" v-for="(item, index) in messageList" :key="index" @click="messageDetail(item.id)">
            <p class="title">
              <span class="cube">公告</span>
              <span class="title">{{item.title}}</span>
              <span class="date">{{item.createTime.slice(0,10)}}</span>
            </p>
            <p class="content">{{item.content}}<p/>
          </div>
        </van-list>
      </van-pull-refresh>
    </section>
  </div>
</template>

<script>
// import { localStorage } from '@utils/basicUtil'
import { messageRequest } from '@services'
import { Notify, PullRefresh, List } from 'vant'

export default {
  data () {
    return {
      searchInput: '',
      messageList: [
      ],
      total: 0,
      pageParams: {
        current: 1,
        size: 10
      },
      refreshing: false,
      loading: false,
      finished: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.refreshing = true
      this.messageList = []
      this.pageParams.current = 1
      this.getMessageList()
    },
    async getMessageList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await messageRequest.message.list({
        ...this.pageParams,
        desc: ['create_time'],
        titleOrContent: this.searchInput
      })
      if (data.success) {
        if (data.result.records) {
          this.messageList = [...this.messageList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      this.loading = false
    },
    onLoad () {
      this.pageParams.current++
      this.getMessageList()
    },
    messageDetail (id) {
      this.$router.push(`/message/detail?id=${id}`)
    }
  },
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List
  }
}
</script>

<style lang="less" scoped>
  .message-wrp {
    width: 100%;
    position: relative;
    height: 100%;
    padding: 20px 30px 0;
    box-sizing: border-box;
    header {
      width: 100%;
      height: 96px;
      font-size: 32px;
      font-weight: bold;
      background: white;
      text-align: center;
      line-height: 96px;
      color: #333;
    }
    section {
      .search-ipt {
        width: 100%;
        margin: 0 auto;
        font-size: 26px;
        font-weight: 400;
        border-radius: 12px;
        border: none;
        height: 70px;
        overflow: hidden;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search-input{
          height: 100%;
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top-left-radius: 12px;
          border-bottom-left-radius: 12px;
          border: 1PX solid #e5e6ea;
          border-right: 0;
          box-sizing: border-box;
          padding-left: 20px;
          input {
            border: 0;
            height: 30px;
            vertical-align: center;
            width: calc(100% - 50px);
            color: rgba(0, 0, 0, 0.8);
            outline: none;
            &::placeholder {
              color: rgba(187, 186, 186, 1);
            }
          }
        }
        .search-icon{
          width: 164px;
          height: 100%;
          background: #2372FF;
          font-size: 30px;
          color: #fff;
          line-height: 70px;
          text-align: center;
          border-top-right-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }
      .message {
        border-radius: 12px;
        box-sizing: border-box;
        margin: 20px auto;
        padding: 30px 25px 10px;
        // height: 220px;
        background: white;
        .title {
          height: 50px;
          line-height: 50px;
          font-size: 28px;
          color: #000;
          font-weight: 400;
          font-family: 'PingFang SC';
          display: flex;
          align-items: center;
          .cube {
            display: block;
            min-width: 59px;
            height: 35px;
            background: #F98417;
            font-family: 'PingFang SC';
            font-size: 22px;
            color: #fff;
            line-height: 35px;
            text-align: center;
            margin-right: 11px;
          }
          .title {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .date {
            white-space: nowrap;
            font-size: 22px;
            font-family: 'PingFang SC';
            color: #999;
            font-weight: 400;
            margin-left: 11px;
          }
        }
        .content {
          height: 100px;
          margin: 15px 0 20px;
          font-size: 24px;
          line-height: 55px;
          color: #BFBFBF;
          box-sizing: border-box;
          // border-top: 1PX solid #F7F7F7;
          // border-bottom: 1PX solid #F7F7F7;
          overflow: hidden;
          position: relative;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

      }
    }
  }
</style>
